import { productSelectorStyles } from "@insite/content-library/Components/ProductSelector";
import { css } from "styled-components";

productSelectorStyles.qtyGridItem = {
    width: [12, 12, 2, 1, 1],
};
productSelectorStyles.buttonGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
};